import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { UserContext } from '../App';

const Summary = (props) => {
    const { user } = useContext(UserContext);
    const [transactions, setTransactions] = useState([]);
    const [childCommissions, setChildCommissions] = useState([]);
    const [inviteCommissions, setInviteCommissions] = useState([]); // NEW: Thống kê invite_code
    const [loading, setLoading] = useState(true);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(API_BASE_URL + '/summaryCommissions', {
                params: {
                    username: user?.data[0]?.UserName,
                    id_type: user?.data[0]?.id_type,
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const { transactions } = res.data;
            setTransactions(transactions);
            setFilteredTransactions(transactions);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchChildCommissions = async () => {
        try {
            const res = await axios.get(API_BASE_URL + '/child_commission_by_user', {
                params: { username: user?.data[0]?.UserName },
            });

            const { child_commission_by_user } = res.data;
            setChildCommissions(child_commission_by_user);
        } catch (error) {
            console.error('Error fetching child commissions:', error);
        }
    };

    // NEW: Fetch Invite Code Data
    const fetchInviteCommissions = async () => {
        try {
            const res = await axios.get(API_BASE_URL + '/child_commission_by_user', {
                params: { username: user?.data[0]?.UserName },
            });
            console.log("res",res.data)
            const { invite_commissions } = res.data;
            setInviteCommissions(invite_commissions);
        } catch (error) {
            console.error('Error fetching invite commissions:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchChildCommissions();
        fetchInviteCommissions(); // Fetch invite data
    }, [user]);

    useEffect(() => {
        if (searchQuery === '') {
            setFilteredTransactions(transactions);
        } else {
            setFilteredTransactions(
                transactions.filter((item) =>
                    item.UserName.toLowerCase().includes(searchQuery.toLowerCase())
                )
            );
        }
    }, [searchQuery, transactions]);

    const handleWithdraw = async (userName,totalMoney,type_app="") => {
    const confirmWithdraw = window.confirm(`Bạn có chắc chắn muốn rút ${formatSurplus(totalMoney)} VNĐ cho ${userName}?`);
    if (!confirmWithdraw) return;

    try {
      setLoading(true);
      await axios.post(API_BASE_URL + "/update_commission", {
        username: userName,
        CommissionStatus: 2,
        totalMoney: totalMoney,
        type_app:type_app
         // Truyền thêm totalMoney
      });
      setLoading(false);
      
      const confirm = window.confirm(`Đã thanh toán hoa hồng ${formatSurplus(totalMoney)} VNĐ cho ${userName}`);
      if (confirm) {
        window.location.reload();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
      alert("Lỗi khi rút tiền, vui lòng thử lại.");
    }
  };

    const formatSurplus = (value) => {
        if (value === null || value === undefined) return '0';
        return Number(value).toLocaleString('vi-VN');
    };

    if (loading) {
        return (
            <div className="loading-container">
                <ReactLoading type="spin" color="#000" />
            </div>
        );
    }

    const extractHeaders = (data) => {
        const excludeHeaders = ["UserName", "totalMoney", "totalDeposit"];
        return Object.keys(data)
          .filter((key) => !excludeHeaders.includes(key))
          .concat(["UserName", "totalMoney", "totalDeposit"]);
      };

      const renderTableHeaders = () => {
        const headers = extractHeaders(filteredTransactions[0] || {});
        return (
          <>
            <th key="UserName">TÊN TÀI KHOẢN</th>
            <th key="totalDeposit">TỔNG TIỀN NẠP</th>
            <th key="totalMoney">TỔNG TIỀN HOA HỒNG</th>
            {headers.map((header) => {
              if (header === "UserName" || header === "totalMoney" || header === "totalDeposit") return null;
              return <th key={header}>{header.toUpperCase()}</th>;
            })}
            <th key="action">Hành Động</th>

          </>
        );
      };

      const renderTableData = (sMoney) => {
        const headers = extractHeaders(filteredTransactions[0] || {});
        return (
          <>
            <td>{sMoney.UserName}</td>
            <td>{formatSurplus(sMoney.totalDeposit)}</td>
            <td>{formatSurplus(sMoney.totalMoney)}</td>
            {headers.map((header, index) => {
              if (header === "UserName" || header === "totalMoney" || header === "totalDeposit") return null;
              return <td key={index}>{formatSurplus(sMoney[header])}</td>;
            })}
            <td>
                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleWithdraw(sMoney.UserName, sMoney.totalMoney)}
                >
                    Rút Tiền
                </button>
            </td>
          </>
        );
      };

    return (
        <div className="container">
            {/* Search Input */}
            <div className="my-4">
                <label htmlFor="searchQuery">Tìm kiếm Tài khoản:</label>
                <input
                    id="searchQuery"
                    type="text"
                    className="form-control"
                    placeholder="Nhập tên tài khoản"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {/* Total Money Table */}
            <h2 className="text-center my-4">Tổng tiền nạp thanh toán hoa hồng</h2>
            <div className="table-responsive">
                {filteredTransactions.length > 0 ? (
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                    <tr>{renderTableHeaders()}</tr>
                    </thead>
                    <tbody>
                    {filteredTransactions.map((sMoney, index) => (
                        <tr key={index}>{renderTableData(sMoney)}</tr>
                    ))}
                    
                    </tbody>
                </table>
                ) : (
                <p>
                    Không có dữ liệu.
                </p>
                )}
            </div>

            {/* Child Commissions Table */}
            {/* <h2 className="text-center my-4">Hoa hồng theo ứng dụng</h2>
            <div className="table-responsive">
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                        <tr>
                            <th>Tên tài khoản</th>
                            <th>Loại ứng dụng</th>
                            <th>Hoa hồng</th>
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {childCommissions.map((commission, index) => (
                            <tr key={index}>
                                <td>{commission.UserName}</td>
                                <td>{commission.TypeApp}</td>
                                <td>{formatSurplus(commission.TotalChildCommission)}</td>
                                <td>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleWithdraw(commission.UserName, commission.TotalChildCommission,commission.TypeApp)}
                                    >
                                        Rút Tiền
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}

            {/* Invite Commissions Table */}
            {/* <h2 className="text-center my-4">Thống kê Invite Code</h2>
            <div className="table-responsive">
                <table className="table table-striped table-bordered">
                    <thead className="thead-dark">
                        <tr>
                            <th>Tài khoản cha</th>
                            <th>Tài khoản mời</th>
                            <th>Loại ứng dụng</th>
                            <th>Hoa hồng con</th>
                            <th>Hoa hồng cha</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inviteCommissions.map((invite, index) => (
                            <tr key={index}>
                                <td>{invite.ParentUser}</td>
                                <td>{invite.InvitedUser}</td>
                                <td>{invite.TypeApp}</td>
                                <td>{formatSurplus(invite.TotalChildCommission)}</td>
                                <td>{formatSurplus(invite.TotalParentCommission)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
        </div>
    );
};

export default Summary;
